import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { listDepartmentsQuery } from '@/queries/department.query'
import { Cross2Icon } from '@radix-ui/react-icons'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Table } from '@tanstack/react-table'
import { statuses } from '../data/data'
import { DataTableFacetedFilter } from './data-table-faceted-filter'
import { DataTableViewOptions } from './data-table-view-options'

interface DataTableToolbarProps<TData> {
  table: Table<TData>
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0
  const { data: departments } = useSuspenseQuery(listDepartmentsQuery);

  const departmentsOptions = departments?.map((department) => ({
    label: department.name,
    value: department.id.toString(),
  }))

  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-1 flex-col-reverse items-start gap-y-2 sm:flex-row sm:items-center sm:space-x-2'>
        <Input
          placeholder='Filtrar atendentes...'
          value={(table.getColumn('user.name')?.getFilterValue() as string) ?? ''}
          onChange={(event) =>
            table.getColumn('user.name')?.setFilterValue(event.target.value)
          }
          className='h-8 w-[150px] lg:w-[250px]'
        />
        <div className='flex gap-x-2'>
          {table.getColumn('status') && (
            <DataTableFacetedFilter
              column={table.getColumn('status')}
              title='Status'
              options={statuses}
            />
          )}
          {table.getColumn('departments') && (
            <DataTableFacetedFilter
              column={table.getColumn('departments')}
              title='Departamento'
              options={departmentsOptions}
            />
          )}
        </div>
        {isFiltered && (
          <Button
            variant='ghost'
            onClick={() => table.resetColumnFilters()}
            className='h-8 px-2 lg:px-3'
          >
            Reset
            <Cross2Icon className='ml-2 h-4 w-4' />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  )
}
